import type React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../store/hooks/hooks';
import {
	setLanguage,
	setTheme,
	setUnitSystem,
	setShowHints,
	setEmailNotifications,
	setAutoSaveDrafts,
	type Language,
	type Theme,
	type UnitSystem,
} from '../../store/slices/settingsSlice';

export default function SettingsSection() {
	const { t, i18n } = useTranslation('profile');
	const dispatch = useAppDispatch();
	const {
		language,
		theme,
		unitSystem,
		showHints,
		emailNotifications,
		autoSaveDrafts,
	} = useAppSelector((state) => state.settings);

	const handleLanguageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		const nextLanguage = event.target.value as Language;
		dispatch(setLanguage(nextLanguage));
		i18n.changeLanguage(nextLanguage);
	};

	const handleThemeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		dispatch(setTheme(event.target.value as Theme));
	};

	const handleUnitSystemChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		dispatch(setUnitSystem(event.target.value as UnitSystem));
	};

	return (
		<div className="profile-page__card">
			<h3>{t('settings.title')}</h3>
			<div className="profile-page__list">
				<div className="profile-page__setting-row">
					<span className="profile-page__setting-label">{t('settings.language')}</span>
					<select
						className="profile-page__setting-select"
						value={language}
						onChange={handleLanguageChange}
					>
						<option value="ru">{t('settings.languageOptions.ru')}</option>
						<option value="en">{t('settings.languageOptions.en')}</option>
					</select>
				</div>
				<div className="profile-page__setting-row">
					<span className="profile-page__setting-label">{t('settings.theme')}</span>
					<select
						className="profile-page__setting-select"
						value={theme}
						onChange={handleThemeChange}
					>
						<option value="light">{t('settings.themeOptions.light')}</option>
						<option value="dark">{t('settings.themeOptions.dark')}</option>
						<option value="auto">{t('settings.themeOptions.auto')}</option>
					</select>
				</div>
				<div className="profile-page__setting-row">
					<span className="profile-page__setting-label">{t('settings.unitSystem')}</span>
					<select
						className="profile-page__setting-select"
						value={unitSystem}
						onChange={handleUnitSystemChange}
					>
						<option value="SI">{t('settings.unitSystemOptions.SI')}</option>
						<option value="BIS">{t('settings.unitSystemOptions.BIS')}</option>
					</select>
				</div>
				<label>
					<input
						type="checkbox"
						checked={showHints}
						onChange={(event) => dispatch(setShowHints(event.target.checked))}
					/>
					{t('settings.hints')}
				</label>
				<label>
					<input
						type="checkbox"
						checked={emailNotifications}
						onChange={(event) => dispatch(setEmailNotifications(event.target.checked))}
					/>
					{t('settings.emailNotifications')}
				</label>
				<label>
					<input
						type="checkbox"
						checked={autoSaveDrafts}
						onChange={(event) => dispatch(setAutoSaveDrafts(event.target.checked))}
					/>
					{t('settings.drafts')}
				</label>
			</div>
		</div>
	);
}